/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2025, Zumper
 */

import { falseReducer, payloadReducer, trueReducer } from '@zcode/reducers'
import type { Messages, StreamConversationType } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleAction, handleActions } from 'redux-actions'
import { RECEIVE_STREAM_CONVERSATIONS_DATA, RECEIVE_STREAM_CONVERSATIONS_ERROR } from '../constants'
import type { ActionTypes } from '../types'

export const streamConversations = combineReducers<Messages['streamConversations'], ActionTypes>({
  data: handleActions<Messages['streamConversations']['data'], ActionTypes>(
    {
      [RECEIVE_STREAM_CONVERSATIONS_DATA]: (state, { payload }) => {
        return {
          ...state,
          [payload.streamChannelId]: { data: payload.data, meta: { isError: false } },
        }
      },
      [RECEIVE_STREAM_CONVERSATIONS_ERROR]: (state, { payload }) => {
        return {
          ...state,
          [payload.streamChannelId]: { data: null, meta: { isError: true } },
        }
      },
    },
    {}
  ),
})
